<template>
  <div>
    <header-applis titre="A bientôt à l’Université de Nantes"
                   sous-titre="Vous n’avez pas trouvé le diplôme et/ou la formation que vous recherchez et avez besoin d’un conseil sur l’offre pour arrêter votre choix ?"
                   index-progression-courante="1"/>
    <div class="wrapper__content">
      <p>Prenez contact avec le Service Universitaire d’Information et d’Orientation pour obtenir ce conseil :</p>
      <ul>
        <li>Adresse : SUIO, 110 bd Michelet, 44300 NANTES</li>
        <li><a @click.stop="afficherMail" :href="mailto">{{ courriel }}</a></li>
      </ul>
      <p>Une fois cette identification finalisée, nous vous invitons à reprendre la démarche engagée, nous pourrons alors donner suite à votre demande.</p>
      <envoyer-recapitulatif/>
    </div>
    <footer-applis ecran-precedent="rechercheformation"/>
  </div>
</template>


<script>
import EnvoyerRecapitulatif from '../components/EnvoyerRecapitulatif';
import HeaderApplis from '../components/HeaderApplis';
import FooterApplis from '../components/FooterApplis';

export default {
  name: 'projetnonidentifie',
  data() {
    return {
      courriel: 'Courriel',
      utilisateurMail: 'suio',
      siteMail: 'univ-nantes.fr',
      mailAffiche: false
    }
  },
  components: {
    FooterApplis,
    HeaderApplis,
    EnvoyerRecapitulatif
  },
  methods: {
    afficherMail() {
      this.courriel = 'Courriel : ' + this.getMail();
      this.mailAffiche = true;
    },
    getMail() {
      return this.utilisateurMail + '@' + this.siteMail;
    }
  },
  computed: {
    mailto: function () {
      if (this.mailAffiche) {
        return 'mailto:' + this.getMail();
      }
      return '#';
    }
  }
}
</script>